import { ProfileActionErrors } from '@profile/enums/profile-action-errors';

export const PROFILE_ACTION_ERRORS_MAP = new Map<ProfileActionErrors, string>([
    [ProfileActionErrors.EmailUsedBySameCompanyCustomer, 'PROFILE_COMMON.ERRORS.EMAIL_USED_BY_SAME_COMPANY_CUSTOMER'],
    [ProfileActionErrors.EmailUsedByAnotherCompanyCustomer, 'PROFILE_COMMON.ERRORS.EMAIL_USED_BY_ANOTHER_COMPANY_CUSTOMER'],
    [ProfileActionErrors.EmailExistsWithinAnotherAccount, 'PROFILE_COMMON.ERRORS.EMAIL_EXISTS_WITHIN_ANOTHER_ACCOUNT'],
    [ProfileActionErrors.InviteOneMoreChildAccountFailed, 'PROFILE_COMMON.ERRORS.INVITE_ONE_MORE_CHILD_ACCOUNT_FAILED']
]);